export default __webpack_public_path__ + "static/media/bycicle.6cb3d511.svg";